module.exports = __webpack_public_path__ + "img/permissions.f017cefa.svg";